import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONTROL } from '../../../../components';
import styles from "../../../styles.module.css";
import { generateCpuItems, generateRamItems, getDisk, getEip, getObs } from '../../../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DbClassTypeItem = {
  Cluster: 'cluster',
  Replica: 'replica'
};
var dbClassTypeItems = [{
  value: DbClassTypeItem.Cluster,
  label: 'Кластер'
}, {
  value: DbClassTypeItem.Replica,
  label: 'Реплика'
}];
var CpuRamMap = {
  '2': [4, 8],
  '4': [8, 16],
  '8': [16, 32],
  '16': [32, 64],
  '32': [64, 128],
  '64': [128, 256]
};
var getNodeControls = function getNodeControls(_ref) {
  var prefix = _ref.prefix;
  return {
    cpu: {
      type: CONTROL.Segmented,
      accessorKey: "".concat(prefix, ".cpu"),
      defaultValue: '2',
      items: generateCpuItems([2, 4, 8, 16, 32, 64]),
      decoratorProps: {
        label: 'Количество vCPU'
      }
    },
    ram: {
      type: CONTROL.Segmented,
      accessorKey: "".concat(prefix, ".ram"),
      defaultValue: '4',
      items: generateRamItems([4, 8]),
      decoratorProps: {
        label: 'Объём RAM'
      },
      watchedControls: {
        cpu: "".concat(prefix, ".cpu")
      },
      relateFn: function relateFn(_ref2) {
        var cpu = _ref2.cpu;
        var items = CpuRamMap[cpu] || [];
        return {
          items: generateRamItems(items)
        };
      }
    },
    counter: {
      type: CONTROL.Stepper,
      accessorKey: "".concat(prefix, ".counter"),
      defaultValue: 2,
      decoratorProps: {
        label: 'Количество Node'
      },
      uiProps: {
        min: 2,
        max: 16,
        postfix: 'Шт'
      }
    },
    eip: getEip({
      trafficKey: "".concat(prefix, ".eip.traffic"),
      velocityKey: "".concat(prefix, ".eip.velocity"),
      specificationKey: "".concat(prefix, ".eip.specification"),
      switchKey: "".concat(prefix, ".eipIsNeeded")
    })
  };
};
var mongosNodeControls = getNodeControls({
  prefix: 'mongosNode'
});
var shardNodeControls = getNodeControls({
  prefix: 'shardNode'
});
var configNodeControls = getNodeControls({
  prefix: 'configNode'
});
var replicaNodeControls = getNodeControls({
  prefix: 'replica'
});
var getReplica = function getReplica() {
  return {
    type: CONTROL.Object,
    ui: [['cpu', 'ram'], ['disk', 'storage']],
    controls: {
      cpu: replicaNodeControls.cpu,
      ram: replicaNodeControls.ram,
      disk: getDisk({
        space: {
          accessorKey: 'replica.diskSpace',
          defaultValue: 10,
          uiProps: {
            min: 10,
            max: 2000
          }
        },
        specification: {
          defaultValue: 'SSD',
          accessorKey: 'replica.specification',
          uiProps: {
            disabled: true
          }
        }
      }),
      storage: getObs({
        space: {
          accessorKey: 'replica.storage.space',
          defaultValue: 1,
          uiProps: {
            min: 1
          }
        },
        units: {
          accessorKey: 'replica.storage.unitsOfCalculation'
        }
      })
    }
  };
};
export var DOCUMENT_DATABASE_FORM_CONFIG = {
  ui: [['dbClassType'], 'clusterDbClassTypeObj', 'replicaDbClassTypeObj'],
  controls: {
    dbClassType: {
      type: CONTROL.Segmented,
      accessorKey: 'dbClassType',
      items: dbClassTypeItems,
      defaultValue: DbClassTypeItem.Cluster,
      decoratorProps: {
        label: 'Тип базы данных',
        labelTooltip: /*#__PURE__*/_jsxs("ul", {
          className: styles.tip,
          children: [/*#__PURE__*/_jsx("li", {
            children: "\u041A\u0430\u0436\u0434\u044B\u0439 \u043A\u043B\u0430\u0441\u0442\u0435\u0440 DDS \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0441\u043E\u0431\u043E\u0439 \u043D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u0443\u044E \u0431\u0430\u0437\u0443 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432. \u0421\u0435\u0433\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043A\u043B\u0430\u0441\u0442\u0435\u0440 \u0441\u043E\u0441\u0442\u043E\u0438\u0442 \u0438\u0437 \u043D\u043E\u0434\u044B \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u0438 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u043D\u043E\u0434 mongos \u0438 shard"
          }), /*#__PURE__*/_jsx("li", {
            children: "\u041D\u0430\u0431\u043E\u0440 \u0440\u0435\u043F\u043B\u0438\u043A \u0441\u043E\u0441\u0442\u043E\u0438\u0442 \u0438\u0437 \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0432 mongod. \u042D\u0442\u043E \u043D\u0430\u0431\u043E\u0440 \u043D\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043F\u043E\u043C\u043E\u0433\u0430\u044E\u0442 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0442\u044C \u0440\u0435\u0437\u0435\u0440\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0438 \u043D\u0430\u0434\u0435\u0436\u043D\u043E\u0441\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0445"
          })]
        })
      }
    },
    clusterDbClassTypeObj: {
      type: CONTROL.Object,
      ui: ['mongosNode', 'shardNode', 'configNode', 'replica'],
      controls: {
        mongosNode: {
          type: CONTROL.Object,
          ui: [['cpu', 'ram'], ['counter'], 'eip'],
          decoratorProps: {
            label: 'Mongos Node',
            labelTooltip: 'Каждый mongos представляет собой отдельную ноду, которая пересылает запросы на чтение и запись данных'
          },
          controls: {
            cpu: mongosNodeControls.cpu,
            ram: mongosNodeControls.ram,
            counter: _objectSpread(_objectSpread({}, mongosNodeControls.counter), {}, {
              decoratorProps: {
                label: 'Количество Mongos Node'
              }
            }),
            eip: mongosNodeControls.eip
          }
        },
        shardNode: {
          type: CONTROL.Object,
          ui: [['cpu', 'ram'], ['disk', 'counter'], 'eip'],
          decoratorProps: {
            label: 'Shard Node',
            labelTooltip: 'Каждый шард (shard) представляет собой набор реплик из трех нод'
          },
          controls: {
            cpu: shardNodeControls.cpu,
            ram: shardNodeControls.ram,
            counter: _objectSpread(_objectSpread({}, shardNodeControls.counter), {}, {
              decoratorProps: {
                label: 'Количество Shard Node',
                labelTooltip: 'Каждому Shard Node присваивается отдельный системный диск'
              }
            }),
            eip: shardNodeControls.eip,
            disk: getDisk({
              space: {
                accessorKey: 'shardNode.diskSpace',
                defaultValue: 10,
                uiProps: {
                  min: 10,
                  max: 1000
                }
              },
              specification: {
                defaultValue: 'SSD',
                accessorKey: 'shardNode.specification',
                uiProps: {
                  disabled: true
                },
                onChangeFn: function onChangeFn() {}
              }
            })
          }
        },
        configNode: {
          type: CONTROL.Object,
          ui: [['cpu', 'ram'], ['disk', 'storage'], 'eip'],
          decoratorProps: {
            label: 'Config Node',
            labelTooltip: 'Нода конфигурации (config) является необходимой частью экземпляра кластера, а также развертывается как набор реплик. Она хранит данные конфигурации экземпляра'
          },
          controls: {
            cpu: _objectSpread(_objectSpread({}, configNodeControls.cpu), {}, {
              defaultValue: '2',
              items: generateCpuItems([2]),
              relateFn: undefined,
              watchedControls: undefined
            }),
            ram: _objectSpread(_objectSpread({}, configNodeControls.ram), {}, {
              defaultValue: '4',
              items: generateRamItems([4]),
              relateFn: undefined,
              watchedControls: undefined
            }),
            disk: getDisk({
              space: {
                accessorKey: 'configNode.diskSpace',
                defaultValue: 20,
                uiProps: {
                  min: 20,
                  max: 20,
                  disabled: true
                }
              },
              specification: {
                defaultValue: 'SSD',
                accessorKey: 'configNode.specification',
                uiProps: {
                  disabled: true
                },
                onChangeFn: function onChangeFn() {}
              }
            }),
            storage: getObs({
              space: {
                accessorKey: 'configNode.storage.space',
                defaultValue: 1,
                uiProps: {
                  min: 1
                }
              },
              units: {
                accessorKey: 'configNode.storage.unitsOfCalculation'
              }
            }),
            eip: mongosNodeControls.eip
          }
        },
        replica: {
          type: CONTROL.ToggleObject,
          switchKey: 'replicaIsNeeded',
          control: getReplica(),
          decoratorProps: {
            label: 'Реплика'
          }
        }
      },
      watchedControls: {
        dbClassType: 'dbClassType'
      },
      relateFn: function relateFn(_ref3) {
        var dbClassType = _ref3.dbClassType;
        if (dbClassType === DbClassTypeItem.Replica) {
          return {
            visible: false
          };
        }
      }
    },
    replicaDbClassTypeObj: {
      type: CONTROL.Object,
      ui: ['replica'],
      controls: {
        replica: getReplica()
      },
      watchedControls: {
        dbClassType: 'dbClassType'
      },
      relateFn: function relateFn(_ref4) {
        var dbClassType = _ref4.dbClassType;
        if (dbClassType !== DbClassTypeItem.Replica) {
          return {
            visible: false
          };
        }
      }
    }
  }
};